import { render, staticRenderFns } from "./IconMeerwaarde.vue?vue&type=template&id=d7ccfec0"
import script from "./IconMeerwaarde.vue?vue&type=script&lang=ts"
export * from "./IconMeerwaarde.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports